import { LAYOUT_TYPES } from '@shared/config/constants/app';
import { useQuery } from '@shared/hooks/useQuery';

export const useWideLayout = () => {
  const { query } = useQuery();

  const layoutType = query.get('layout_type') || null;

  const isTVLayout = layoutType?.toLowerCase() === LAYOUT_TYPES.TV;
  const isWEBLayout = layoutType?.toLowerCase() === LAYOUT_TYPES.WEB;

  return {
    isTVLayout,
    isWEBLayout,
  };
};
